import axios from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'
import { api, baseURL, get, post, put } from '../axios'
import { z } from 'zod'
import { ApplicationInput, Configuration, configuration, managedForm, publicForm, receipt } from './public-form'

// No dashboard token refresh, notifications, or error telemetry for applicant data.
const publicApi = axios.create({
    baseURL,
})
export async function fetchPublicForm(publicId: string) {
    return publicForm.parse(camelizeKeys((await publicApi.get(`/public-forms/${publicId}`)).data))
}
/**
 * The sample form of a website and the origin of its wp-admin, for the form style preview in the WordPress plugin.
 */
export async function fetchSiteFormPreview(siteKey: string) {
    return z
        .object({ origin: z.string(), configuration })
        .parse(camelizeKeys((await publicApi.get(`/site-forms/${siteKey}/preview`)).data))
}
export async function submitApplication(publicId: string, input: ApplicationInput) {
    return receipt.parse(
        camelizeKeys((await publicApi.post(`/public-forms/${publicId}/submissions`, decamelizeKeys(input))).data)
    )
}
export async function fetchReceipt(publicId: string, receiptId: string) {
    return receipt.parse(camelizeKeys((await publicApi.get(`/public-forms/${publicId}/submissions/${receiptId}`)).data))
}
export async function fetchManagedForm(campaignId: string) {
    return get(managedForm, `/campaigns/${campaignId}/public-form`)
}
export async function saveDraft(campaignId: string, draft: Configuration) {
    return put(managedForm, `/campaigns/${campaignId}/public-form`, draft)
}
export async function publishForm(campaignId: string) {
    return post(managedForm, `/campaigns/${campaignId}/public-form/publish`)
}
export async function unpublishForm(campaignId: string) {
    return post(managedForm, `/campaigns/${campaignId}/public-form/unpublish`)
}
export async function uploadLogo(campaignId: string, logo: File): Promise<string> {
    const data = new FormData()
    data.append('logo', logo)
    const response = await api.post(`/campaigns/${campaignId}/public-form/logo`, data, {
        transformRequest: [],
        headers: { 'Content-Type': undefined },
    })
    return z.object({ logoUrl: z.string() }).parse(response.data).logoUrl
}
export function assetUrl(path: string) {
    return import.meta.env.DEV && path.startsWith('/api/')
        ? `${new URL(import.meta.env.VITE_API_URL ?? 'http://localhost/api').origin}${path}`
        : path
}
